import * as React from 'react';
import FormItem from 'antd/lib/form/FormItem';
import Input from 'antd/lib/input';

export interface ReleaseNameFormItemProps {
    disabled?: boolean;
    hidden?: boolean;
    placeholder?: string;
    labelCol?: { flex: string };
}

export const ReleaseNameFormItem: React.FC<ReleaseNameFormItemProps> = ({
    disabled = false,
    hidden = false,
    placeholder = 'Odyssey',
    labelCol = { flex: '130px' },
}) => {
    return (
        <FormItem
            label="Release name"
            name="releaseName"
            rules={[{ required: false }]}
            extra={<span style={{ fontSize: 13 }}>A human-friendly name for your release</span>}
            hidden={hidden}
            labelCol={labelCol}
        >
            <Input style={{ fontSize: 18 }} disabled={disabled} autoComplete="off" placeholder={placeholder} />
        </FormItem>
    );
};
